function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, ButtonGroup, Divider, Flex, HStack, Icon, IconButton, SimpleGrid, Spinner, Stack, Switch, Text, Tooltip } from '@chakra-ui/react';
import Panel from '../Panel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk, faBan, faBook, faCog, faFilter, faFont, faIcons, faLinkSlash, faRetweet } from '@fortawesome/free-solid-svg-icons';
import useChannelStore from '@/stores/ChannelStore';
import { getSpamProtectionFilters, updateSpamProtectionFilter } from '@/actions/SpamProtectionActions';
import { SpamProtectionFilterTypes, AuthProviders } from '@/types/server';
import { useNavigate } from 'react-router';
import { DynamicWebRoutes } from '@/utils/constants';
import { Helmet } from 'react-helmet';
import { getChannelProviderSettings, updateChannelProviderSettings } from '@/actions/ChannelActions';
var _obj;
var IconByFilterType = (_obj = {}, _define_property(_obj, SpamProtectionFilterTypes.CAPS, faFont), _define_property(_obj, SpamProtectionFilterTypes.EMOTES, faIcons), _define_property(_obj, SpamProtectionFilterTypes.LINKS, faLinkSlash), _define_property(_obj, SpamProtectionFilterTypes.REPETITIONS, faRetweet), _define_property(_obj, SpamProtectionFilterTypes.BLACKLIST, faBan), _define_property(_obj, SpamProtectionFilterTypes.SYMBOLS, faAsterisk), _obj);
var LOADING_SYMBOL = Symbol('loading');
function SpamProtectionPanel(param) {
    var type = param.type, name = param.name, description = param.description, enabled = param.enabled, onToggle = param.onToggle, documentationUrl = param.documentationUrl;
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var navigate = useNavigate();
    var intl = useIntl();
    function handleToggle() {
        setLoading(true);
        onToggle().finally(function() {
            return setLoading(false);
        });
    }
    var _IconByFilterType_type;
    return /*#__PURE__*/ _jsxs(Panel, {
        as: Flex,
        flexDir: "column",
        gap: 0,
        padding: 0,
        children: [
            /*#__PURE__*/ _jsxs(HStack, {
                flex: 1,
                padding: 6,
                spacing: 6,
                userSelect: "none",
                isTruncated: true,
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        marginBottom: 1,
                        padding: 3,
                        borderRadius: "lg",
                        as: FontAwesomeIcon,
                        icon: (_IconByFilterType_type = IconByFilterType[type]) !== null && _IconByFilterType_type !== void 0 ? _IconByFilterType_type : faFilter,
                        bgColor: "borderSecondary"
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                size: "sm",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                color: "textSecondary",
                                whiteSpace: "initial",
                                children: description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs(ButtonGroup, {
                size: "sm",
                spacing: 6,
                alignItems: "center",
                padding: 4,
                paddingX: 6,
                isTruncated: true,
                children: [
                    /*#__PURE__*/ _jsxs(HStack, {
                        flex: 1,
                        spacing: 4,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Switch, {
                                alignItems: 'center',
                                colorScheme: "primary",
                                isChecked: enabled,
                                isDisabled: loading,
                                onChange: handleToggle
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                flex: 1,
                                fontSize: "sm",
                                color: "textSecondary",
                                children: enabled ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "V52jNn",
                                    defaultMessage: "Enabled"
                                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "tthToS",
                                    defaultMessage: "Disabled"
                                })
                            })
                        ]
                    }),
                    documentationUrl != null && documentationUrl.length > 0 || type != null ? /*#__PURE__*/ _jsxs(ButtonGroup, {
                        size: "sm",
                        color: "textSecondary",
                        spacing: 4,
                        children: [
                            documentationUrl != null && documentationUrl.length > 0 ? /*#__PURE__*/ _jsx(Tooltip, {
                                label: intl.formatMessage({
                                    id: "isGKnz",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Documentation"
                                        }
                                    ]
                                }),
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    onClick: function() {
                                        return window.open(documentationUrl, '_blank');
                                    },
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faBook
                                    }),
                                    "aria-label": intl.formatMessage({
                                        id: "isGKnz",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Documentation"
                                            }
                                        ]
                                    })
                                })
                            }) : null,
                            type != null ? /*#__PURE__*/ _jsx(Tooltip, {
                                label: intl.formatMessage({
                                    id: "D3idYv",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Settings"
                                        }
                                    ]
                                }),
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    onClick: function() {
                                        return navigate(DynamicWebRoutes.SPAM_PROTECTION_FILTER(type));
                                    },
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faCog
                                    }),
                                    "aria-label": intl.formatMessage({
                                        id: "D3idYv",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Settings"
                                            }
                                        ]
                                    })
                                })
                            }) : null
                        ]
                    }) : null
                ]
            })
        ]
    });
}
export default function SpamProtection() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), filters = _React_useState[0], setFilters = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(LOADING_SYMBOL), 2), channelProviderSettings = _React_useState1[0], setChannelProviderSettings = _React_useState1[1];
    React.useEffect(function() {
        if ((channel === null || channel === void 0 ? void 0 : channel._id) == null) {
            return;
        }
        getSpamProtectionFilters(channel._id).then(function(filters) {
            return setFilters(filters);
        }).catch(console.error);
        getChannelProviderSettings(channel._id).then(function(settings) {
            return setChannelProviderSettings(settings);
        }).catch(console.error);
    }, [
        channel === null || channel === void 0 ? void 0 : channel._id
    ]);
    function handleFilterToggle(filter) {
        return _handleFilterToggle.apply(this, arguments);
    }
    function _handleFilterToggle() {
        _handleFilterToggle = _async_to_generator(function(filter) {
            var updatedFilter;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            updateSpamProtectionFilter(channel._id, {
                                _type: filter._type,
                                enabled: !filter.enabled
                            })
                        ];
                    case 1:
                        updatedFilter = _state.sent();
                        setFilters(function(filters) {
                            if (filters == null) {
                                return filters;
                            }
                            var index = filters.findIndex(function(f) {
                                return f._type === updatedFilter._type;
                            });
                            if (index === -1) {
                                return filters;
                            }
                            var newFilters = _to_consumable_array(filters);
                            newFilters[index] = updatedFilter;
                            return newFilters;
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFilterToggle.apply(this, arguments);
    }
    function handleProviderSettingToggle(settingKey, newSettingValue) {
        return _handleProviderSettingToggle.apply(this, arguments);
    }
    function _handleProviderSettingToggle() {
        _handleProviderSettingToggle = _async_to_generator(function(settingKey, newSettingValue) {
            var updatedSettings;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            updateChannelProviderSettings(channel._id, _define_property({}, settingKey, newSettingValue))
                        ];
                    case 1:
                        updatedSettings = _state.sent();
                        setChannelProviderSettings(updatedSettings);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleProviderSettingToggle.apply(this, arguments);
    }
    if (filters == null || channel == null || channelProviderSettings === LOADING_SYMBOL) {
        return /*#__PURE__*/ _jsx(DashboardLayout, {
            children: /*#__PURE__*/ _jsx(Box, {
                width: "100%",
                height: "100%",
                display: "grid",
                placeItems: "center",
                children: /*#__PURE__*/ _jsx(Spinner, {})
            })
        });
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "71AfYn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Chat Moderation"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "Rq+Paf",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage chat restrictions and spam filters"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "71AfYn",
                    defaultMessage: "Chat Moderation"
                })
            }),
            /*#__PURE__*/ _jsxs(SimpleGrid, {
                columns: 1,
                spacing: 6,
                minChildWidth: "300px",
                children: [
                    (filters !== null && filters !== void 0 ? filters : []).map(function(filter) {
                        return /*#__PURE__*/ _jsx(SpamProtectionPanel, {
                            type: filter._type,
                            name: filter._name,
                            description: filter._description,
                            enabled: filter.enabled,
                            documentationUrl: filter._docs,
                            onToggle: function() {
                                return handleFilterToggle(filter);
                            }
                        }, filter._type);
                    }),
                    channel.provider === AuthProviders.TWITCH && channelProviderSettings != null ? /*#__PURE__*/ _jsx(SpamProtectionPanel, {
                        name: intl.formatMessage({
                            id: "/uQQds",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Shared Chat"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "kwqXby",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "This setting will enable filtering of messages sent from other channels shared to your chat."
                                }
                            ]
                        }),
                        enabled: channelProviderSettings.sourceChatFiltering,
                        onToggle: function() {
                            return handleProviderSettingToggle('sourceChatFiltering', !channelProviderSettings.sourceChatFiltering);
                        }
                    }) : null
                ]
            })
        ]
    });
}
